var Component     = require("enyo/Component"),
    config        = require("app/config"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    kind          = require("enyo/kind");

/**
 * Manage which buttons should be enabled in the header. Either in the
 * horizontal menu or the vertical one.
 *
 * This list does not include buttons that show and hide themselves.
 */
module.exports = kind(/** @lends  app.AppHeader.ButtonRequirements.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.ButtonRequirements",

    /**
     * @private
     */
    kind: Component,

    /**
     * The state of the AppHeader.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    backButton: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    languageSwitcher: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    signUpButton: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    loginButton: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    previewModeButton: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    playlistsButton: get(config, "pageUrls.playlistsPageUrl", null),

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    bookmarksButton: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    genresButton: get(config, "pageUrls.genresPageUrl", null),

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    artistsButton: get(config, "pageUrls.artistsPageUrl", null),

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    categoryDropdown: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    brandDropdown: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    profileButton: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    privacyButton: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    faqButton: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    contactButton: false,

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    logoutButton: false,

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.header.showBackButton", this.update);
            this.observe("app.$.authService.user", this.update);
            this.update();
        };
    }),

    /**
     * @type {Boolean}
     * @readonly
     * @public
     */
    update: function() {
        var state      = this.state || {},
            $appHeader = this.app.$.header.$.headerView,
            user       = this.app.$.authService.user,
            language   = this.app.$.i18nService.get("language");

        this.backButton        = Boolean(this.app.$.header.showBackButton);
        this.languageSwitcher  = get(state, "languages.length", 0) > 1;
        this.signUpButton      = $appHeader.$.signUpButton.shouldShow();
        this.loginButton       = $appHeader.$.loginButton.shouldShow();
        this.previewModeButton = get(user, "preview_mode_type", false);
        this.bookmarksButton   = $appHeader.$.bookmarksButton.shouldShow();
        this.categoryDropdown  = get(state, "categories", []).length > 0;
        this.brandDropdown     = get(state, "brands", []).length > 0;
        this.profileButton     = $appHeader.$.menuDropdown.$.profileButton.shouldShow();
        this.privacyButton     = Boolean(get(config, "privacyUrl." + language, null));
        this.faqButton         = Boolean(get(config, "faqUrl." + language, null));
        this.contactButton     = Boolean(get(config, "contactUrl." + language, null));
        this.logoutButton      = $appHeader.$.menuDropdown.$.logoutButton.shouldShow();
        this.bubbleUp("onButtonRequirementsChanged");
    }

});
